import { makeStyles, styled } from "@mui/styles";
import React, { useEffect } from "react";
import { Box, CardActions, CardContent, Divider, Grid, TableCell, tableCellClasses, Typography } from "@mui/material";
import ApexCharts from "react-apexcharts";
import { useTranslation } from "react-i18next";
import cssVariables from "../../theme/cssVariables";
import planningImg from "../../assets/images/home/planning.svg";
import bannerBg from "../../assets/images/home/home-banner-bg.svg";

styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#163263',
    },
    [`&.${tableCellClasses.body}`]: {
        'border-width': 0,
        'padding-left': 0,
    },
}));
const styles = {
    paperContainer: {
        backgroundImage: `url(${bannerBg})`,
        width: "100%",
        minHeight: 200,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        borderRadius: "10px",
        position: "relative",
    },
    bannerImage: {
        position: "absolute",
        bottom: 0,
        width: "100%",
        maxWidth: "336px",
        height: "auto",
    },
    blueBadge: {
        background: "rgb(186, 217, 87,0.15)",
        padding: "5px 12px",
        color: "#93AC41",
        // opacity: "0.15",
    },
    barLegend: {
        fontSize: "14px",
        lineHeight: "19px",
        color: "#939393",
    }
};
const useStyles = makeStyles({
    media: {
        height: 200,
    },
    iconContainer: {
        width: 40,
        height: 40,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    blueBg: {
        background: "#6694CC",
    },
    purpleBg: {
        background: "#7580BD",
    },
    customCardSize: {
        height: 380,
    },
    cardContentSize: {
        display: "flex",
        justifyContent: "center",
        flexFlow: "column",
        alignItems: "center",
        height: "calc(100% - 130px)",
    },
});

function BarLegend(props) {
    // const { data, colors } = props
    const data = props.data;
    let row = [];
    let percent = (data) => {
        let sumpercent = 0
        if (data > 0) {
            sumpercent = ((data / props.totalScore) * 100)
        }
        return sumpercent.toFixed(2)
    }
    for (var i = 0; i < data.series.length; i++) {
        row.push(
            <Box key={data.series[i].id} display="flex" alignItems="center">
                <Box sx={{ width: "10%" }} mr="2.5">
                    <div className="bar-legend-square" style={{ backgroundColor: data.options.colors[i] }}></div>
                </Box>
                <Box sx={{ width: "50%", overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" }} px="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={300}> {data.options.labels[i]}</Typography></Box>
                <Box sx={{ width: "20%" }} px="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={500}> {data.series[i]}</Typography></Box>
                <Box sx={{ width: "20%" }} pl="2.5px"><Typography variant="label" style={styles.barLegend} fontWeight={300}>({data.series[i]}%)</Typography></Box>
            </Box>
        );
    }
    return (row)
}

export default function GoalsStatus(props) {
    const { t } = useTranslation();
    const { datas, dataPA } = props;
    const classes = useStyles();
    const [typeList, setTypeList] = React.useState([]);
    const [score, setScore] = React.useState(0);
    const [criterionScore, setCriterionScore] = React.useState([0]);
    const [colorBar, setColor] = React.useState([]);
    const [dataBarChart, setDataBarChart] = React.useState([]);

    let chartOptions = {
        series: [
            {
                name: "Goals",
                data: [5, 1, 4, 3, 2, 4, 2, 4, 3, 2, 4, 2],
            },
            {
                name: "Competencies",
                data: [2, 2, 3, 5, 1, 4, 3, 3, 5, 1, 4, 3],
            },
            {
                name: "Goals & Competencies",
                data: [6, 7, 1, 2, 1, 1, 2, 1, 2, 1, 1, 2],
            },
            {
                name: "Others",
                data: [6, 7, 1, 2, 1, 1, 2, 1, 2, 1, 1, 2],
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: "100px",
                stacked: true,
                toolbar: {
                    show: false,
                }
            },
            colors: [
                "#FA9349",
                "#74C1ED",
                "#F7B254",
                "#31B09B",
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 5,
                    columnWidth: "40%"
                },
            },
            dataLabels: {
                enabled: false
            },
            grid: {
                show: false
            },
            stroke: {
                width: 1,
                colors: ["#fff"],
            },
            title: {
                show: false
            },
            xaxis: {
                categories: ["Sep-20", "Oct-20", "Nov-20", "Dec-20", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20"],
                labels: {
                    formatter: function (val) {
                        return val;
                    },
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                title: {
                    text: undefined,
                },
            },
            tooltip: {
                enabled: true,
                enabledOnSeries: undefined,
                shared: true,
                followCursor: false,
                intersect: false,
                inverseOrder: false,
                custom: undefined,
                fillSeriesColor: false,
                style: {
                    fontSize: '16px',
                    fontFamily: "Kanit",
                    fontWeight: 300,
                },
                onDatasetHover: {
                    highlightDataSeries: false,
                },
                x: {
                    show: true,
                    formatter: function (value, opts) {
                        let total = opts.w.globals.stackedSeriesTotals[opts.dataPointIndex];
                        return "Total: " + total
                    }
                },
                y: {
                    formatter: undefined,
                    title: {
                        formatter: (seriesName) => seriesName + ":",
                    },
                },
                z: {
                    formatter: undefined,
                    title: 'Size: '
                },
                marker: {
                    show: true,
                },
                items: {
                    display: "flex",
                },
                fixed: {
                    enabled: false,
                    position: 'topRight',
                    offsetX: 0,
                    offsetY: 0,
                },
            },
            fill: {
                opacity: 1,
            },
            legend: {
                show: false,
                position: "top",
                horizontalAlign: "right",
            },
        }
    };

    return (
        <Box px={2} pt={1}>
            <CardContent className={classes.cardContentSize} sx={{ justifyContent: "flex-start", alignItems: "flex-start", padding: "10px 0" }} style={{ "padding-bottom": "0px" }}>
                <Box sx={{ width: "100%", position: "relative", "border-left": "1px solid #E5E5E5", }}>
                    <Box sx={{ display: "flex", "justify-content": "space-between" }}>
                        <Box sx={{ display: "flex", width: "295px" }} pl="25px" pr="10px">
                            <Typography fontSize={24} lineHeight="26.4px" fontWeight={500} color="#404349" sx={{ textAlign: "left", "white-space": "nowrap" }}>
                                My Achievements
                            </Typography>
                            <Box ml="15px" sx={{ background: "rgba(93, 161, 150, 0.15)", width: "max-content", padding: "0 8px", "border-radius": "2px", height: "25px" }}>
                                <Typography fontSize={16} lineHeight="24px" fontWeight={500} color="#5DA196" sx={{ textAlign: "left" }}>
                                    45
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", "flex-flow": "row wrap", width: "calc(100% - 295px)", "max-width": "max-content" }}>
                            {
                                chartOptions.series.length > 0 ? chartOptions.series.map((loRow, index) => (
                                    <Box key={index} display="flex" alignItems="center">
                                        <Box sx={{ width: "15px", height: "15px" }} mr="2.5">
                                            <div className="bar-legend-square" style={{ backgroundColor: chartOptions.options.colors[index] }}></div>
                                        </Box>
                                        <Box sx={{ width: "max-content", overflow: "hidden", "white-space": "nowrap", "text-overflow": "ellipsis" }} px="10px"><Typography variant="label" style={styles.barLegend} fontWeight={300}> {loRow.name}</Typography></Box>
                                    </Box>
                                ))
                                    : null
                            }
                        </Box>
                    </Box>
                    <Box sx={{
                        ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" },
                        ".apexcharts-tooltip-y-group > span": { "font-weight": "400" },
                        ".apexcharts-tooltip": {
                            background: "#F7F7F7",
                            "font-weight": "400",
                        }, height: "240px",
                        ".apexcharts-legend-text": {
                            color: "#A3A3A3 !important",
                        },
                        ".apexcharts-text": {
                            color: "#A3A3A3 !important",
                            fill: "#A3A3A3  !important"
                        },
                        ".apexcharts-tooltip-title": {
                            background: "#5DA196 !important",
                            color: "#FFFFFF",
                            "font-weight": "400",
                        }
                    }}>
                        <ApexCharts
                            options={chartOptions.options}
                            series={chartOptions.series}
                            type={chartOptions.options.chart.type}
                            height="100%"
                        ></ApexCharts>
                    </Box>
                </Box>
            </CardContent >
        </Box >
    )
}

